export function cloneJson(jsonValue) {
    return JSON.parse(JSON.stringify(jsonValue));
}